import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=cdfd9318&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=cdfd9318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfd9318",
  null
  
)

export default component.exports